import SvgIcon from "./IconCheck.svg?react";
const IconCheck = SvgIcon;
export default IconCheck;
